import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [desktopServicesOpen, setDesktopServicesOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);

  const dropdownRef = useRef(null);

  // Close desktop dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDesktopServicesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const closeMobileMenu = () => {
    setMenuOpen(false);
    setMobileServicesOpen(false);
  };

  return (
    <>
      {/* HEADER */}
      <header className="header">
        <div className="header-container">

          {/* LOGO */}
          <div className="logo">
            <Link to="/">
              <img src={`${process.env.PUBLIC_URL}/assets/images/logo.jpg`} alt="INTEL BUILD Logo" />
            </Link>
          </div>

          {/* DESKTOP NAV */}
          <nav className="nav">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>

              {/* SERVICES DROPDOWN */}
              <li className="dropdown" ref={dropdownRef}>
                <button
                  className="dropdown-trigger"
                  onClick={() =>
                    setDesktopServicesOpen(!desktopServicesOpen)
                  }
                  aria-expanded={desktopServicesOpen}
                >
                  <Link to="/services" onClick={() => setDesktopServicesOpen(false)}>
  Services
</Link>

                  <FaChevronDown
                    className={desktopServicesOpen ? "rotate" : ""}
                  />
                </button>

                {desktopServicesOpen && (
                  <ul className="dropdown-menu simple-list">
                    <li>
                      <Link to="/services/oil-gas">
                        Oil & Gas
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/pre-engineered-buildings">
                        Pre-Engineered Buildings
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/real-estate">
                        Real Estate
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/bim-services">
                        BIM Services
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/sustainable-design">
                        Sustainable Design & Engineering
                      </Link>
                    </li>
                    <li>
                      <Link to="/services/structural-audit">
                        Structural Audit
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/featured-news">Feature News</Link></li>
            </ul>
          </nav>

          {/* CTA */}
          <Link to="/contact" className="desktop-cta">
            <button className="header-btn">Get Started</button>
          </Link>

          {/* MOBILE ICON */}
          <div
            className="mobile-menu-btn"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </div>
        </div>
      </header>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="mobile-menu">
          <Link to="/" onClick={closeMobileMenu}>Home</Link>
          <Link to="/about" onClick={closeMobileMenu}>About</Link>

          <div className="mobile-services">
            <div
              className="mobile-services-header"
              onClick={() =>
                setMobileServicesOpen(!mobileServicesOpen)
              }
            >
              <Link to="/services" onClick={() => setDesktopServicesOpen(false)}>
  Services
</Link>

              <FaChevronDown
                className={mobileServicesOpen ? "rotate" : ""}
              />
            </div>

            {mobileServicesOpen && (
              <div className="mobile-services-list">
                <Link to="/services/oil-gas" onClick={closeMobileMenu}>
                  Oil & Gas
                </Link>
                <Link
                  to="/services/pre-engineered-buildings"
                  onClick={closeMobileMenu}
                >
                  Pre-Engineered Buildings
                </Link>
                <Link to="/services/real-estate" onClick={closeMobileMenu}>
                  Real Estate
                </Link>
                <Link to="/services/bim-services" onClick={closeMobileMenu}>
                  BIM Services
                </Link>
                <Link
                  to="/services/sustainable-design"
                  onClick={closeMobileMenu}
                >
                  Sustainable Design & Engineering
                </Link>
                <Link
                  to="/services/structural-audit"
                  onClick={closeMobileMenu}
                >
                  Structural Audit
                </Link>
              </div>
            )}
          </div>

          <Link to="/projects" onClick={closeMobileMenu}>Projects</Link>
          <Link to="/careers" onClick={closeMobileMenu}>Careers</Link>
          <Link to="/featured-news" onClick={closeMobileMenu}>Feature News</Link>
          <Link to="/contact" onClick={closeMobileMenu}>Contact</Link>
        </div>
      )}
    </>
  );
};

export default Header;
